import React, { useContext, useState, useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { FormatDate, Formathhmm, FormatIST } from "../../utils/dateFormat";
import { leaderBoardAPI } from "../../store/actions";
import { FormLoader } from "../../utils/Loader";
import "../../assets/css/gamifyy/normalize.css";
import "../../assets/css/gamifyy/webflow.css";
import "../../assets/css/gamifyy/gamify.css";
import "../../assets/css/leaderboard.css";
import { getCleanImageUrl } from "../../utils";
import { AuthContext } from "../../utils/CompanyContext";

const GameTitleHeader = (props) => {
  return (
    <div className="game-tile-header" key={props.key}>
      <div>
        <div>
          <strong>{props.headerTitle}</strong>
        </div>
        <div className="bold-text-10">{props.headerText}</div>
      </div>
    </div>
  );
};

const LeaderBoardGameModal = ({ clickedRow, showModal, toggleModal }) => {
  const dispatch = useDispatch();
  const { varcharemployeeid, LoginEmail } = useContext(AuthContext);
  const [showAnonymized, setShowAnonymized] = useState(false);

  const {
    activeOrganizationInfo,
    gameByIdInfo,
    isFetching,
    leaderBoardInfo,
    percentileFlag,
  } = useSelector(
    ({
      get_active_organization_detail: { data: activeOrganizationData },
      leader_board_api: { data: leaderBoardData, isFetching },
    }) => {
      return {
        activeOrganizationInfo: activeOrganizationData || {},
        gameByIdInfo: leaderBoardData?.gamedata,
        leaderBoardInfo: leaderBoardData,
        percentileFlag: leaderBoardData?.percentileFlag,
        isFetching: isFetching,
      };
    },
    shallowEqual,
  );
  const dashboardConfigurationInfo = useSelector(
    (state) => state.get_dashboard_configuration_values.data,
  );
  const loggedEmployeeId =
    varcharemployeeid?.toUpperCase() || LoginEmail?.toUpperCase();
  const updateHeights = () => {
    const winHeight = window.innerHeight;
    document
      .querySelectorAll(
        ".game-section, .video-background-section, .video-wrap, .video-embed",
      )
      .forEach((el) => {
        el.style.height = `${winHeight}px`;
      });

    const divBlockHeight = document.querySelector(".div-block-568--new");
    if (divBlockHeight) {
      const fullTabHeight = winHeight - divBlockHeight.offsetHeight - 100;
      document.querySelector(".lead_hei").style.height = `${fullTabHeight}px`;
    }
  };
  useEffect(() => {
    updateHeights();

    window.addEventListener("resize", updateHeights);

    dispatch(
      leaderBoardAPI({
        companyguid: activeOrganizationInfo?.Companyguid,
        Organization: activeOrganizationInfo?.Organization,
        GameId: clickedRow?.gameid || clickedRow?.gameId,
        Primaryprogram: activeOrganizationInfo?.Program,
      }),
    );
    return () => {
      window.removeEventListener("resize", updateHeights);
    };
  }, []);
  useEffect(() => {
    if (dashboardConfigurationInfo?.length > 0) {
      const ranksConfig = dashboardConfigurationInfo.find(
        (c) => c.configurationName === "GAMEANONYMIZE",
      );
      const ranksConfigValue = ranksConfig?.configurationValue || null;
      let isAnonymized = ranksConfigValue === "Y";
      const titleRole = activeOrganizationInfo?.titlerolename || null;

      if (titleRole !== "L1") {
        isAnonymized = false;
      }
      setShowAnonymized(isAnonymized);
    }
  }, [dashboardConfigurationInfo, activeOrganizationInfo]);

  const {
    createdByEmployeeName,
    gameStatus,
    gameName,
    gameId,
    metricname,
    startdate,
    gameTimeFrame,
    startdatetime,
    enddatetime,
    gameWinnerType,
    numberOfWinners,
    thresholdDsiplayValue,
    gameBadgeidUrl,
    dataLastUpdatedDateTime,
    gameThemeUrl,
  } = gameByIdInfo?.[0] || {};

  useEffect(() => {
    if (gameTimeFrame === "I") {
      const interval = setInterval(() => {
        dispatch(
          leaderBoardAPI({
            companyguid: activeOrganizationInfo?.Companyguid,
            Organization: activeOrganizationInfo?.Organization,
            GameId: clickedRow?.gameid || clickedRow?.gameId,
            Primaryprogram: activeOrganizationInfo?.Program,
          }),
        );
      }, 600000);

      return () => clearInterval(interval);
    }
  }, [gameTimeFrame, activeOrganizationInfo, clickedRow]);

  const gameHeader = [
    {
      headerTitle: "Game Organizer",
      headerText: createdByEmployeeName,
    },
    {
      headerTitle: "Game Status",
      headerText: gameStatus,
    },
    {
      headerTitle: "Game",
      headerText: gameName,
    },
    {
      headerTitle: "Metric",
      headerText: metricname,
    },
  ];
  const sortedLeaderBoard = [
    ...(leaderBoardInfo?.gameleaderboard_data || []),
  ].sort((a, b) => {
    if (a.memberRank === null) return 1;
    if (b.memberRank === null) return -1;
    return a.memberRank - b.memberRank;
  });
  const getBarPercentage = (rank) => {
    const constasub = 98;
    let barpercentage = 2;

    if (rank !== null && rank !== undefined) {
      barpercentage = constasub - rank;
    }

    if (barpercentage <= 0) {
      barpercentage = 1;
    }

    return barpercentage;
  };
  const getProgressPercentage = () => {
    if (!startdate || !enddatetime) return 100;

    const start = new Date(startdate);
    const end = new Date(enddatetime);
    const today = new Date();

    if (start.getTime() === end.getTime()) return 100;

    const percent = ((today - start) / (end - start)) * 100;

    return Math.max(0, Math.min(100, Math.round(percent)));
  };
  let i = 0;
  const currentUserRow = sortedLeaderBoard.find(
    (x) => x.gameMemberEmployeeid?.toUpperCase() === loggedEmployeeId,
  );

  return (
    <Modal
      isOpen={showModal}
      toggle={toggleModal}
      //   className={className}
      backdrop={true}
      keyboard={true}
      fullscreen={true}
      id="leaderboard-game_modal"
    >
      <ModalBody id="" className="p-0">
        {isFetching ? (
          <div className="text-center">
            <FormLoader width={800} />
          </div>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 game_leaderboard pd-0">
                <div className="position-relative">
                  <div className="game-section">
                    <div className="d-flex">
                      <div className="div-block-568--new">
                        {gameHeader.map((item, index) => (
                          <GameTitleHeader
                            key={index}
                            headerTitle={item.headerTitle}
                            headerText={item.headerText}
                          />
                        ))}
                        <div className="game-tile-header range">
                          <div>
                            <div>
                              <strong>Start</strong>
                            </div>
                            <div className="bold-text-10 w-embed w-script">
                              <span id="gameStartDate">
                                {gameTimeFrame === "I"
                                  ? `${FormatDate(startdate)} ${Formathhmm(
                                      startdatetime,
                                    )}`
                                  : FormatDate(startdate)}
                              </span>
                            </div>
                          </div>
                          <div className="div-block-570">
                            <div
                              className="div-block-571 _5p"
                              style={{ width: `${getProgressPercentage()}%` }}
                            />
                            <div className="div-block-572"></div>
                          </div>
                          <div>
                            <div>
                              <strong>End</strong>
                            </div>
                            <div className="bold-text-10 w-embed w-script">
                              <span id="gameEndDate">
                                {gameTimeFrame == "I"
                                  ? `${FormatDate(enddatetime)} ${Formathhmm(
                                      enddatetime,
                                    )}`
                                  : FormatDate(enddatetime)}
                              </span>
                            </div>
                          </div>
                        </div>
                        <GameTitleHeader
                          headerTitle="Type"
                          headerText={gameWinnerType}
                        />

                        {gameByIdInfo &&
                          (gameWinnerType?.toLowerCase() === "rank" ? (
                            <GameTitleHeader
                              headerTitle="No. of Winners"
                              headerText={numberOfWinners}
                            />
                          ) : (
                            <GameTitleHeader
                              headerTitle="Threshold Value"
                              headerText={thresholdDsiplayValue}
                            />
                          ))}
                        <div className="game-tile-header badge-space">
                          <img
                            src={getCleanImageUrl(gameBadgeidUrl)}
                            loading="lazy"
                            alt=""
                            className="image-153"
                          />
                        </div>
                      </div>
                      {/* <div className="menu_icon">
                        <img src="images/messageicn.svg" />
                      </div> */}
                    </div>
                    <div className="">
                      {/* leaderBoardInfo */}
                      <div className="div-block-841">
                        <div className="div-block-837 lead_hei">
                          <div className="div-block-682">
                            <div className="div-block-849">
                              {currentUserRow && (
                                <div className="game-row leader-collection leader_highlight toprank_game_cell">
                                  <div className="game-cell rank">
                                    <div>{currentUserRow.memberRank}</div>
                                  </div>

                                  <div className="game-cell name">
                                    <div>
                                      {currentUserRow.gameMembeEmployeeName}
                                    </div>
                                  </div>

                                  <div className="game-cell stretch">
                                    <div className="game-status-bar">
                                      <div
                                        className="game-status-bar-active _95p"
                                        style={{
                                          width: `${getBarPercentage(currentUserRow.memberRank)}%`,
                                        }}
                                      />
                                      <div className="game-status-bar-bg">
                                        <div className="div-block-850">
                                          <img
                                            src={getCleanImageUrl(
                                              gameBadgeidUrl,
                                            )}
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="game-cell score">
                                    {percentileFlag
                                      ? currentUserRow.memberMetricPercentileValue ||
                                        "0.00"
                                      : currentUserRow.memberMetricDsiplayValue}
                                  </div>
                                </div>
                              )}

                              {sortedLeaderBoard?.map((item, index) => {
                                const barpercentage = getBarPercentage(
                                  item.memberRank,
                                );
                                const isCurrentUser =
                                  item.gameMemberEmployeeid?.toUpperCase() ===
                                  loggedEmployeeId;
                                const shouldAnonymize =
                                  showAnonymized && !isCurrentUser;
                                return (
                                  <div
                                    key={index}
                                    className={`game-row leader-collection ${
                                      isCurrentUser ? "leader_highlight" : ""
                                    }`}
                                  >
                                    <div className="game-cell rank">
                                      <div>{item.memberRank}</div>
                                    </div>

                                    <div className="game-cell name">
                                      <div>
                                        {shouldAnonymize
                                          ? "Team Member"
                                          : item.gameMembeEmployeeName}
                                      </div>
                                    </div>

                                    <div className="game-cell stretch">
                                      <div className="game-status-bar">
                                        <div
                                          className="game-status-bar-active _95p"
                                          style={{ width: `${barpercentage}%` }}
                                        />
                                        <div className="game-status-bar-bg">
                                          <div className="div-block-850">
                                            <img
                                              src={getCleanImageUrl(
                                                gameBadgeidUrl,
                                              )}
                                              alt=""
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="game-cell score">
                                      {percentileFlag
                                        ? item.memberMetricPercentileValue ||
                                          "0.00"
                                        : item.memberMetricDsiplayValue}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="localtimeconversion"
                      id="lastupdateddatetime"
                    >
                      Updated Through {FormatIST(dataLastUpdatedDateTime)}
                    </div>
                  </div>
                </div>
                <div className="video-background-section">
                  <div
                    className="video-wrap"
                    style={{
                      zIndex: "unset",
                    }}
                  >
                    <div className="video-embed w-embed w-iframe">
                      {gameThemeUrl != null && gameThemeUrl.includes(".mp4") ? (
                        <video
                          autoPlay
                          loop
                          muted
                          playsInline
                          id="myVideo"
                          className="leaderboard__video video_hei"
                        >
                          <source
                            src={getCleanImageUrl(gameThemeUrl)}
                            type="video/mp4"
                          />
                        </video>
                      ) : (
                        <img
                          className="video_hei"
                          src={getCleanImageUrl(gameThemeUrl)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-3 pd-0 gray_bg hid">
                <div className="game_hd">
                  <div>
                    <h3>Game Chat</h3>
                  </div>
                  <div className="closee">
                    <img src="~/Content/assets/images/cross.svg" />
                  </div>
                </div>
                <div id="partialgamechat"></div>
              </div> */}
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};
export default LeaderBoardGameModal;
